module.exports = global["surveylab_page_samePageItemValue"] = require("-!/app/node_modules/ts-loader/index.js??ref--4!./same-page-item-value.ts");